import { apiPrivate } from './api';

export const notificationService = {
  list: () => apiPrivate.get('/api/notifications').then((r) => r.data),
  markAsRead: (id) => apiPrivate.post(`/api/notifications/${id}/read`).then((r) => r.data),
  markAllAsRead: () => apiPrivate.post('/api/notifications/read-all').then((r) => r.data),
  getPreferences: () => apiPrivate.get('/api/notification-preferences').then((r) => r.data),
  updatePreferences: (data) => apiPrivate.put('/api/notification-preferences', data).then((r) => r.data)
};
